import ComingSoon from './ComingSoon';
import './ComingSoon.scss';

export default ComingSoon;
